import { Component } from '@angular/core';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface AccordionFieldProps extends FormlyFieldProps {
  multiple?: boolean;
}

@Component({
  selector: 'accordion-field',
  standalone: true,
  imports: [...FORM_IMPORTS, AccordionModule, ButtonModule],
  template: `
    <p-accordion [multiple]="props.multiple ?? false">
      @for (
        step of field.fieldGroup;
        track step;
        let index = $index;
        let first = $first, last = $last
      ) {
        <p-accordion-panel [value]="index + 1">
          <p-accordion-header>
            <div class="flex gap-2 flex-wrap items-center">
              <span
                class="{{
                  !isValid(step)
                    ? 'text-[var(--p-form-field-invalid-placeholder-color)] italic'
                    : ''
                }}"
                >{{ step.props?.label }}</span
              >
              <small
                class="text-[var(--p-form-field-invalid-placeholder-color)] italic"
              >
                <formly-validation-message
                  class="ui-message-text"
                  [field]="step"
                ></formly-validation-message>
              </small>
            </div>
          </p-accordion-header>
          <p-accordion-content class="p-0">
            <formly-field [field]="step"></formly-field>
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  `,
})
export class AccordionFieldType extends FieldType<
  FieldTypeConfig<AccordionFieldProps>
> {
  isValid(field: FormlyFieldConfig): boolean {
    if (field.key) {
      return field.formControl!.valid;
    }

    return field.fieldGroup
      ? field.fieldGroup.every((f) => this.isValid(f))
      : true;
  }

  isDirty(field: FormlyFieldConfig): boolean {
    if (field.key) {
      return field.formControl!.dirty;
    }

    return field.fieldGroup
      ? field.fieldGroup.every((f) => this.isDirty(f))
      : true;
  }
  isTouched(field: FormlyFieldConfig): boolean {
    if (field.key) {
      return field.formControl!.touched;
    }

    return field.fieldGroup
      ? field.fieldGroup.every((f) => this.isTouched(f))
      : true;
  }
}
